import { CHANGE_VIEW_PROJECT_TAB } from "../actions/viewProjectTabAction";

const initialState = {
  initialTab: 0,
  tabValues: {},
};

const viewProjectTabReducer = (state = initialState, action) => {
  if(action.type === CHANGE_VIEW_PROJECT_TAB){
    return {
        ...state,
        initialTab: action.payload,
      };
  }else{
    return state;
  }
};

export default viewProjectTabReducer;
